import { statusTypes } from './shared'

export const appEnabled = (status) => {
    return (
        status === statusTypes.Activated ||
        status === statusTypes.Registered ||
        status === statusTypes.CustomerDisabled ||
        status === statusTypes.PendingValidation
    )
}
